export const getVideoHeightAndWidth = (
  url: string,
): Promise<{ videoWidth: number; videoHeight: number }> => {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.src = url;

    video.addEventListener('loadedmetadata', function () {
      return resolve({ videoWidth: this.videoWidth, videoHeight: this.videoHeight });
    });

    video.addEventListener('error', () => {
      reject('Video format cannot be read.');
    });
  });
};
